import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Slide12Closing() {
  return <div className="w-full h-full flex flex-col items-center justify-center relative" data-id="element-348">
      {/* Cinematic Background Core */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-349">
        <motion.div className="w-[800px] h-[800px] rounded-full bg-gradient-to-tr from-snakker-primary/15 to-snakker-secondary/15 blur-[120px]" initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} data-id="element-350" />

        {/* Data points flowing in */}
        <svg className="absolute inset-0 w-full h-full" data-id="element-351">
          {[...Array(24)].map((_, i) => {
          const angle = i * 15 * (Math.PI / 180);
          const startX = 50 + Math.cos(angle) * 50 + '%';
          const startY = 50 + Math.sin(angle) * 50 + '%';
          return <motion.circle key={i} r="2.5" fill={i % 2 === 0 ? 'rgba(0,133,189,0.7)' : 'rgba(124,92,245,0.6)'} initial={{
            cx: startX,
            cy: startY,
            opacity: 0
          }} animate={{
            cx: '50%',
            cy: '50%',
            opacity: [0, 1, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            delay: i * 0.18,
            ease: 'easeInOut'
          }} data-id="element-352" />;
        })}
        </svg>

        {/* Central core */}
        <motion.div className="absolute w-32 h-32 rounded-full bg-white border border-snakker-border shadow-[0_0_60px_rgba(0,133,189,0.3)] flex items-center justify-center" initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.5,
        duration: 1,
        type: 'spring'
      }} data-id="element-353">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-snakker-primary to-snakker-secondary" data-id="element-354" />
        </motion.div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-5xl" data-id="element-355">
        <motion.h1 className="text-[clamp(2.5rem,4.5vw,4.8rem)] leading-[1.1] font-light tracking-tight mb-6 text-snakker-ink" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-356">
          Every interaction{' '}
          <span className="text-snakker-subtle" data-id="element-357">teaches.</span>
          <br data-id="element-358" />
          Every answer <span className="text-snakker-subtle" data-id="element-359">reveals.</span>
          <br data-id="element-360" />
          Every campaign{' '}
          <span className="text-gradient-accent font-medium" data-id="element-361">learns.</span>
        </motion.h1>

        <motion.p className="text-xl text-snakker-muted font-light mb-12 mt-8" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.4
      }} data-id="element-362">
          Snakker turns engagement into strategic intelligence.
        </motion.p>

        <motion.button className="group inline-flex items-center gap-3 bg-snakker-ink text-white px-10 py-5 rounded-full font-medium tracking-wide hover:bg-snakker-primary transition-colors text-lg shadow-lg" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.8
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-363">
          Explore the Intelligence Layer
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-364" />
        </motion.button>
      </div>
    </div>;
}